// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Urbanist:ital,wght@0,100..900;1,100..900&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  font-family: "Urbanist", sans-serif !important;
}

/* 
scss
 */
/* 
Body Theme Color
 */
/* 
Dark Theme Colors
*/
/* 
Button Theme
*/
/* 
Max Dashboard scss
*/
/* 
Min Dashboard scss
*/
/* 
Max Dashboard scss
*/
.viewUser_dashboard__iThb1 {
  width: calc(100% - 320px);
  position: relative;
  left: 310px;
  padding: 30px;
  border-radius: 8px;
  min-height: auto !important;
  background-color: #F5F6FA;
  height: calc(100vh - 160px);
  overflow-y: auto;
}

.viewUser_dashboardContain__2kzL3 {
  width: calc(100% - 320px);
  background-Color: #F5F6FA;
  border-radius: 8px;
}

.viewUser_bodythemedark__wulnI .viewUser_dashboardContain__2kzL3,
.viewUser_bodythemedark__wulnI .viewUser_dashboard__iThb1,
.viewUser_bodythemedark__wulnI .viewUser_cont2__-kuqZ {
  background-Color: #0f1824;
}

.viewUser_top_header__7hDIR .viewUser_top_header_inner__M6rMm {
  background-color: transparent;
  height: auto;
  overflow-y: unset;
}

/* 
Min Dashboard scss
*/
.viewUser_cont2__-kuqZ {
  width: calc(100% - 50px);
  left: 50px;
  position: relative;
  padding: 30px;
  border-radius: 8px;
  background: #F5F6FA;
  height: calc(100vh - 160px);
  min-height: auto !important;
  overflow-y: auto;
  /* 
  background-Color: \$dashboardbackgroundColor;
    padding-bottom: 8%;
  */
}

.viewUser_footer__jbCYz {
  height: 70px;
}

body {
  background-color: #fff;
}

/* 
THEME CHANGE
*/
.viewUser_bodythemelight__0PGJc {
  background-color: #fff;
  padding-top: 90px;
}

.viewUser_bodythemedark__wulnI {
  background-color: #132337;
  padding-top: 90px;
}

/* 
Header Navbar Theme
*/
.viewUser_headerthemelight__SlKj2 {
  background-color: #fff;
}

.viewUser_headerthemedark__NMtco {
  background-color: #132337;
}

.viewUser_top_header__7hDIR {
  min-height: 90px;
  display: flex;
  align-items: center;
  position: fixed;
  width: 100%;
  z-index: 1;
  top: 0;
}

/* 
LEFT MENU THEME CHANGE
*/
.viewUser_menuthemelight__V31yz {
  background-color: #fff;
}

.viewUser_menuthemedark__YSvyO {
  background-color: #132337;
}

/* 
LEFT MENU LINKS THEME CHANGE
*/
.viewUser_menulinklight__TMqfU span {
  color: #666666 !important;
}

.viewUser_menulinklight__TMqfU a {
  color: #CBCBCB !important;
}

.viewUser_menulinklight__TMqfU:hover span, .viewUser_menulinklight__TMqfU:hover a {
  color: #fff !important;
}

.viewUser_menulinkdarkSelected__QX0Vz {
  background-color: #1c2e45;
  color: #3b82f6;
}

.viewUser_menuthemelight__V31yz .viewUser_menulinklightSelected__jqaxe {
  /*background-color: \$lightthemecolor;*/
  color: #fff !important;
  background-color: #131F43;
}

.viewUser_menulinkdark__rBWoe {
  color: #92afd3 !important;
}

.viewUser_menulinklight__TMqfU:hover {
  color: #fff !important;
  background-color: #131F43;
}

.viewUser_menulinklight__TMqfU .viewUser_sub_arrow__ZXCe2 svg path {
  stroke: #CBCBCB !important;
}

.viewUser_menulinklight__TMqfU:hover .viewUser_sub_arrow__ZXCe2 svg path {
  stroke: #fff !important;
}

.viewUser_menulinkdark__rBWoe .viewUser_sub_arrow__ZXCe2 svg path {
  stroke: #92afd3 !important;
}

.viewUser_menulinkdark__rBWoe:hover .viewUser_sub_arrow__ZXCe2 svg path {
  stroke: #fff !important;
}

.viewUser_menulinkdark__rBWoe:hover {
  background-color: #1c2e45;
  color: #fff;
}

/* 
BODY HEADERS
*/
.viewUser_headinglight__3ordU {
  color: #60677e;
}

.viewUser_headingdark__YUOnG {
  color: #60677e;
}

/* 
SEARCH BOX THEME COLOR
*/
.viewUser_searchboxlight__lT-JP {
  background-color: #fff;
  border: none;
}

.viewUser_searchboxdark__IaMcG {
  background-color: #132337;
  color: #fff;
  border: none;
}

.viewUser_searchboxdark__IaMcG::placeholder {
  color: #60677e;
}

/* 
CUSTOM TABLE THEME COLOR
*/
.viewUser_tableheadlight__ucFTs {
  background-color: #131F43;
  border-radius: 5px 5px 0px 0px;
}

.viewUser_tableheadlight__ucFTs th {
  color: #fff;
}

thead .viewUser_tableheadlight__ucFTs th:first-child,
thead .viewUser_tableheaddark__U9m4X th:first-child {
  border-radius: 5px 0 0 0px;
}

thead .viewUser_tableheadlight__ucFTs th:last-child,
thead .viewUser_tableheaddark__U9m4X th:last-child {
  border-radius: 0 5px 0px 0;
}

th:first-child {
  border-radius: 0px;
}

td:last-child {
  border-radius: 0px;
}

table.viewUser_table__\\+Pzzo.viewUser_table-borderless__rPFk2 {
  border-collapse: separate !important;
  border-spacing: 0 0px !important;
}

.viewUser_tableheaddark__U9m4X {
  background-color: #132337;
  color: #fff;
}

.viewUser_table-borderless__rPFk2 tr:nth-child(even) {
  background-color: #F9FAFB;
}

.viewUser_table-borderless__rPFk2 .viewUser_left-section__xMnO3 {
  padding-top: 10px;
}

.viewUser_tablebodylight__kEXJa td,
.viewUser_tablebodydark__aRWdM td {
  padding: 0.5rem 1rem !important;
  line-height: 45px;
}

.viewUser_tablebodylight__kEXJa {
  background-color: #fff;
}
.viewUser_tablebodylight__kEXJa:hover {
  background-color: #ddecf9;
  cursor: auto;
}

.viewUser_tablebodydark__aRWdM {
  /* background-color: \$primarydark-color; */
  color: #60677e;
}
.viewUser_tablebodydark__aRWdM:hover {
  background-color: rgba(33, 150, 243, 0.1);
  cursor: auto;
}

/* 
PAGINATION THEME COLOR
*/
.viewUser_paginationlight__0df3c {
  color: #60677e !important;
  font-size: 13px !important;
}

.viewUser_paginationdark__2SShC {
  color: #60677e !important;
  font-size: 13px !important;
}

/* 
SETTING FORM THEME COLOR
*/
.viewUser_formthemelight__l7JgF {
  background-color: #fff;
  color: #1d1d1d !important;
  box-shadow: 0px 10px 35px 0px rgba(56, 71, 109, 0.08);
}

.viewUser_formthemedark__O6Pbp {
  background-color: #132337;
  color: #60677e !important;
  font-size: 14px;
}
.viewUser_formthemedark__O6Pbp ::placeholder {
  color: #60677e;
}

/* 
VIEW FORM DETAILS BOX THEME COLOR
*/
.viewUser_viewformlight__fWN3w {
  background-color: #f3f6f9;
}

.viewUser_permissionboxlight__g2Jzw {
  background-color: #f8f9fa;
  border: 1px solid #dee2e6;
}

.viewUser_permissionboxdark__u5Qv4 {
  background-color: #0f1824;
  border: solid 1px #242434;
}

.viewUser_errormsgclr__c9\\+6D {
  color: red;
  font-size: 14px;
  margin-top: 5px;
}

/* 
Graph theme
*/
.viewUser_graphclrlight__qXmCC {
  background-color: #fff;
}

.viewUser_graphclrdark__0JXBj {
  background-color: #132337;
}

/* 
Counter theme
*/
#viewUser_card1bglight__5BhlI {
  /* background: linear-gradient(90deg, rgba(181, 219, 177, 1) 13%, rgba(125, 178, 144, 1) 100%); */
  background-color: #fff;
}

#viewUser_card1bgdark__NLxYm {
  background: #392f28;
}

#viewUser_card2bglight__zKXly {
  /* background: linear-gradient(90deg, rgba(243, 198, 165, 1) 0%, rgba(248, 163, 168, 1) 100%); */
  background-color: #fff;
}

#viewUser_card2bgdark__UDFQ\\+ {
  background: #1c3238;
}

#viewUser_card3bglight__ivWjs {
  /* background: linear-gradient(90deg, rgba(213, 149, 211, 1) 0%, rgba(174, 132, 192, 1) 100%); */
  background-color: #fff;
}

#viewUser_card3bgdark__qWBhh {
  background: #3a2434;
}

#viewUser_card4bglight__ThLGp {
  /* background: linear-gradient(90deg, rgba(140, 212, 214, 1) 0%, rgba(150, 202, 247, 1) 100%); */
  background-color: #fff;
}

#viewUser_card4bgdark__fZIls {
  background: #2f264f;
}

#viewUser_card1bgdark__NLxYm a, #viewUser_card1bgdark__NLxYm p,
#viewUser_card2bgdark__UDFQ\\+ a, #viewUser_card2bgdark__UDFQ\\+ p,
#viewUser_card3bgdark__qWBhh a, #viewUser_card3bgdark__qWBhh p,
#viewUser_card4bgdark__fZIls a, #viewUser_card4bgdark__fZIls p {
  color: #fff;
}

/* 
Action button theme
*/
.viewUser_actionbtnlight__XcYy0 {
  color: rgba(70, 71, 91, 0.8705882353);
}

.viewUser_actionbtnlight__XcYy0:hover {
  cursor: pointer;
}

.viewUser_actionbtndark__s2vFY {
  color: #60677e;
}

/* 
profile dropdowntheme
*/
.viewUser_profiledropdownlight__LuxDl {
  background-color: #fff;
}

.viewUser_profiledropdowndark__WGyp9 {
  background-color: #151521;
}

.viewUser_settingsection__I1Pyw #viewUser_addform__sOr4v.viewUser_formthemedark__O6Pbp .viewUser_savebtn__Z\\+kf3 {
  background-color: #3b82f6;
  color: #fff;
}

#viewUser_addform__sOr4v.viewUser_formthemedark__O6Pbp .viewUser_savebtn__Z\\+kf3 {
  background-color: #3b82f6;
  color: #fff;
}

.viewUser_profile_conatiner__NCKkX {
  border-radius: 5px !important;
}

.viewUser_bodythemedark__wulnI .viewUser_ag-theme-alpine__oTcfv .viewUser_ag-row__lSzTA {
  background: #000 !important;
}

.viewUser_bodythemedark__wulnI .viewUser_formbtn__0o0PL {
  background-color: #3b82f6;
}

.viewUser_bodythemedark__wulnI .viewUser_formbtn__0o0PL:hover {
  background-color: #2563eb;
}

.viewUser_bodythemedark__wulnI .viewUser_resetbtn__bmzBN {
  color: #fff;
  background-color: transparent;
  border: solid 1px #3b82f6;
}

.viewUser_bodythemedark__wulnI .viewUser_resetbtn__bmzBN:hover {
  background-color: #3b82f6;
}

.viewUser_headingdark__YUOnG span {
  background-color: #132337;
}

.viewUser_resetbtn__bmzBN {
  font-size: 16px;
  font-weight: 600;
  border-radius: 5px;
  background-color: transparent;
  border: solid 1px #131F43;
  color: #131F43;
  min-width: 113px;
}

.viewUser_resetbtn__bmzBN:hover,
.viewUser_resetbtn__bmzBN:active,
.viewUser_resetbtn__bmzBN:focus {
  background-color: #131F43;
  color: #fff;
}

.viewUser_addBtn__pR\\+UV {
  min-width: 140px;
  height: 44px;
  color: #fff;
  background-color: #38A169;
  border: none;
  font-size: 16px;
  font-weight: 600;
}

.viewUser_addbtnlight__tRx63 {
  background-color: #38A169;
}

.viewUser_addbtndark__9twrN {
  background-color: #3b82f6;
}

.viewUser_addbtndark__9twrN:hover {
  background-color: #2563eb;
}

.viewUser_formthemedark__O6Pbp label {
  color: #92afd3;
}

.viewUser_addBtn__pR\\+UV svg {
  margin-right: 10px;
  position: relative;
  top: 2px;
}

.viewUser_addBtn__pR\\+UV:hover {
  color: #fff;
  background-color: #38A169;
  border: none;
}

.viewUser_cust_addBtn__6Rg36.viewUser_addBtn__pR\\+UV svg {
  top: 2px;
}

.viewUser_deleteBtn__zaPsW {
  min-width: 130px;
  height: 50px;
  background-color: #F94747;
  color: #fff;
  font-size: 16px;
  font-weight: 600;
  border: none;
}

.viewUser_deleteBtn__zaPsW {
  min-width: 130px;
  height: 50px;
  background-color: #F94747;
  color: #fff;
  font-size: 16px;
  font-weight: 600;
  border: none;
}

.viewUser_deleteBtn__zaPsW:active, .viewUser_deleteBtn__zaPsW:focus {
  background-color: #F94747 !important;
  color: #fff !important;
  box-shadow: none !important;
}

.viewUser_deleteBtn__zaPsW svg {
  margin-right: 10px;
  position: relative;
  top: -2px;
}

.viewUser_deleteBtn__zaPsW:hover,
.viewUser_deleteBtn__zaPsW:active,
.viewUser_deleteBtn__zaPsW:focus {
  background-color: #F94747;
  color: #fff;
  border: none;
}

.viewUser_confirmBtn__El-A9 {
  background-color: #131F43;
}

.viewUser_confirmBtn__El-A9:hover,
.viewUser_confirmBtn__El-A9:active,
.viewUser_confirmBtn__El-A9:focus {
  background-color: #131F43;
}

.viewUser_confirmBtn__El-A9 svg {
  top: 0;
}

.viewUser_delPopContainer__t7fHG .viewUser_modal-body__uYle- {
  padding: 25px;
  text-align: center;
}

.viewUser_delPopContainer__t7fHG .viewUser_delet_icon__AoG2x {
  margin-bottom: 11px;
}

.viewUser_delPopContainer__t7fHG p {
  color: #131f43;
  font-size: 14px;
  font-weight: 700;
}

.viewUser_arrowback__C5ITR svg {
  fill: #000;
}

.viewUser_bodythemedark__wulnI .viewUser_arrowback__C5ITR {
  background-color: rgba(59, 130, 246, 0.2);
  color: #3b82f6;
}

.viewUser_bodythemedark__wulnI .viewUser_arrowback__C5ITR svg {
  fill: #3b82f6;
}

.viewUser_bodythemedark__wulnI .viewUser_drpdwn_btn__j\\+g4R {
  background-color: #132337;
}

.viewUser_bodythemedark__wulnI .viewUser_empname__wUtTf {
  color: #92afd3 !important;
}

.viewUser_bodythemedark__wulnI .viewUser_navitemli__rhyKP a {
  background-color: transparent;
  border: solid 1px #3b82f6;
  color: #fff;
}

.viewUser_bodythemedark__wulnI .viewUser_tabnavli__-YHAh a.viewUser_settingsgeneral__KG42X,
.viewUser_bodythemedark__wulnI .viewUser_tabnavli__-YHAh a.viewUser_settingslinks__PQxdD:hover {
  background-color: #3b82f6;
  color: #fff;
}

.viewUser_bodythemedark__wulnI .viewUser_tabnavli__-YHAh a.viewUser_settingslinks__PQxdD {
  background-color: transparent;
  border: solid 1px #3b82f6;
  color: #fff;
}

.viewUser_headerthemedark__NMtco .viewUser_dropdown_menu_contain__t16Qi {
  background-color: #1c2e45;
  color: #fff;
}

.viewUser_headerthemedark__NMtco .viewUser_dropdown_menu_contain__t16Qi ul li a,
.viewUser_headerthemedark__NMtco .viewUser_dropdown_menu_contain__t16Qi .viewUser_dropdown_item__W4kq2,
.viewUser_headerthemedark__NMtco .viewUser_dropdown_menu_contain__t16Qi .viewUser_dropdown_item__W4kq2 h5 {
  color: #fff;
}

.viewUser_headerthemedark__NMtco .viewUser_dropdown_menu_contain__t16Qi ul li a:hover,
.viewUser_headerthemedark__NMtco .viewUser_dropdown_menu_contain__t16Qi .viewUser_dropdown_item__W4kq2:hover {
  background-color: #132337;
  color: #fff;
}

.viewUser_dropdown_item__W4kq2:active {
  background-color: #F5F6FA;
}

.viewUser_profile_arrrow_dwn__qZsYl {
  stroke: #132337;
}

.viewUser_headerthemedark__NMtco .viewUser_profile_arrrow_dwn__qZsYl {
  stroke: #fff;
}

.viewUser_dateinputbox1__jcn-2 input,
.viewUser_dateinputbox1__jcn-2 span {
  color: #fff !important;
}

/* LOGOUT MODAL */
@media only screen and (max-width: 1200px) {
  .viewUser_tableheadlight__ucFTs th {
    min-width: 100px;
  }
}
@media only screen and (max-width: 1024px) {
  .viewUser_dashboard__iThb1 {
    width: calc(100% - 50px) !important;
    left: 50px !important;
    padding: 10px 10px !important;
  }
  .viewUser_cont2__-kuqZ {
    height: calc(100vh - 160px);
    overflow-y: auto;
  }
}
@media only screen and (max-width: 998px) {
  /* #dashboardcont2{
     height: auto !important;
   }*/
}
@media only screen and (max-width: 767px) {
  .viewUser_sectionright__vCzZg {
    float: unset !important;
  }
  .viewUser_dashboard__iThb1 {
    padding: 10px 10px !important;
  }
}
@media only screen and (max-width: 600px) {
  .viewUser_cont2__-kuqZ {
    width: calc(100% - 50px) !important;
    left: 50px !important;
    position: relative !important;
    padding: 10px !important;
  }
  .viewUser_bodythemelight__0PGJc, .viewUser_bodythemedark__wulnI {
    padding-top: 110px;
  }
}
@media (min-width: 576px) {
  .viewUser_exer_modal_contain__7594D .viewUser_modal-dialog__BgNTR {
    max-width: 1055px;
  }
  .viewUser_delPopContainer__t7fHG .viewUser_modal-dialog__BgNTR {
    max-width: 350px;
  }
}
#viewUser_addform__sOr4v {
  width: 100%;
  border-radius: 5px;
  margin-top: 30px;
  margin-bottom: 20px;
}
#viewUser_addform__sOr4v #viewUser_addheading__vGTQP {
  font-size: 18px;
  margin-left: 10px;
}
#viewUser_addform__sOr4v .viewUser_profilepicdiv__DW1M2 {
  padding: 0px;
  border-radius: 5px;
  text-align: center;
}
#viewUser_addform__sOr4v .viewUser_profilepic__PAI2d {
  width: 100%;
  border-radius: 5px;
}
#viewUser_addform__sOr4v .viewUser_namesection__oFNuW {
  display: inline-block;
}
#viewUser_addform__sOr4v .viewUser_profilename__1y1cK {
  font-size: 16px;
  margin-left: 20px;
  margin-top: 30px;
}
#viewUser_addform__sOr4v .viewUser_profileemail__zoh\\+F {
  font-size: 14px;
  margin-left: 20px;
}
#viewUser_addform__sOr4v #viewUser_empdiv__cOJ0m {
  padding: 0px;
  margin-bottom: 20px;
  border-radius: 5px;
  display: flex;
  align-items: center;
  background-color: transparent;
}
#viewUser_addform__sOr4v #viewUser_empdiv__cOJ0m .viewUser_title__NZ-pF {
  font-size: 13px;
}
#viewUser_addform__sOr4v #viewUser_empdiv__cOJ0m .viewUser_empname__wUtTf {
  font-size: 16px;
  color: #131F43;
  font-weight: 600;
  margin-bottom: 0px;
}
#viewUser_addform__sOr4v .viewUser_arrowback__C5ITR {
  float: right;
  background-color: #dde2eb;
  padding: 10px;
  color: #39979d;
  cursor: pointer;
  border-radius: 3px;
}
#viewUser_addform__sOr4v .viewUser_arrowback__C5ITR:hover {
  background-color: #39979d;
  color: #fff;
}

.viewUser_profile_view_container__M3WBK {
  padding: 30px;
}

.viewUser_profile_view_container__M3WBK span {
  font-size: 13px;
  margin-bottom: 7px;
}

.viewUser_formthemedark__O6Pbp.viewUser_profile_view_container__M3WBK span {
  color: #fff;
}

.viewUser_deleteBtn__zaPsW svg {
  margin-right: 0px;
}

@media only screen and (max-width: 992px) {
  .viewUser_profilepicdiv__DW1M2 {
    margin-bottom: 30px;
  }
}
@media only screen and (max-width: 600px) {
  #viewUser_dashboardcont2__nCgwF {
    width: calc(100% - 50px);
    left: 50px;
    position: relative;
    padding: 30px;
  }
}
@media only screen and (max-width: 767px) {
  .viewUser_btn_contain__4cn42 > div {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }
  .viewUser_btn_contain__4cn42 > div button {
    margin-right: 0px !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/Variables/Variables.scss","webpack://./src/pages/users/viewUser.module.scss"],"names":[],"mappings":"AAEA;EACE,8CAAA;ACAF;;ADGA;;EAAA;AAkDA;;EAAA;AAWA;;CAAA;AAKA;;CAAA;AASA;;CAAA;AAQA;;CAAA;AAMA;;CAAA;AAIA;EACE,yBAhBe;EAiBf,kBAAA;EACA,WAhBc;EAiBd,aAhBiB;EAiBjB,kBAAA;EACA,2BAAA;EACA,yBA1FO;EA2FP,2BAAA;EACA,gBAAA;ACxEF;;AD0EA;EACE,yBAAA;EACA,yBAhGO;EAiGP,kBAAA;ACvEF;;ADyEA;;;EAGE,yBAlEoB;ACJtB;;ADwEA;EACE,6BAAA;EACA,YAAA;EACA,iBAAA;ACrEF;;ADwEA;;CAAA;AAIA;EACE,wBAvCU;EAwCV,UAvCS;EAwCT,kBAAA;EACA,aA/CiB;EAgDjB,kBAAA;EACA,mBAxHO;EAyHP,2BAAA;EACA,2BAAA;EACA,gBAAA;EACA;;;GAAA;ACnEF;;AD4EA;EACE,YAAA;ACzEF;;AD4EA;EACE,sBA5FY;ACmBd;;AD4EA;;CAAA;AAGA;EACE,sBAnGY;EAoGZ,iBAAA;ACzEF;;AD2EA;EACE,yBAlHgB;EAmHhB,iBAAA;ACxEF;;AD2EA;;CAAA;AAGA;EACE,sBA/GY;ACuCd;;AD2EA;EACE,yBA9HgB;ACsDlB;;AD0EA;EACE,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;EACA,WAAA;EACA,UAAA;EACA,MAAA;ACvEF;;AD0EA;;CAAA;AAGA;EACE,sBAnIY;AC4Dd;;ADyEA;EACE,yBAjJgB;AC2ElB;;ADyEA;;CAAA;AAGA;EACE,yBAAA;ACtEF;;ADyEA;EACE,yBAAA;ACtEF;;ADyEA;EACE,sBAAA;ACtEF;;ADyEA;EACE,yBAlKsB;EAmKtB,cA7KkB;ACuGpB;;ADwEA;EACE,sCAAA;EACA,sBAAA;EACA,yBA5Mc;ACuIhB;;ADwEA;EACE,yBAAA;ACrEF;;ADwEA;EACE,sBAAA;EACA,yBArNc;ACgJhB;;ADwEA;EACE,0BAAA;ACrEF;;ADwEA;EACE,uBAAA;ACrEF;;ADwEA;EACE,0BAAA;ACrEF;;ADwEA;EACE,uBAAA;ACrEF;;ADwEA;EACE,yBArMsB;EAsMtB,WA7LY;ACwHd;;ADwEA;;CAAA;AAGA;EACE,cAjMe;AC4HjB;;ADwEA;EACE,cArMe;ACgIjB;;ADwEA;;CAAA;AAGA;EACE,sBA/MY;EAgNZ,YAAA;ACrEF;;ADwEA;EACE,yBA/NgB;EAgOhB,WArNY;EAsNZ,YAAA;ACrEF;;ADuEA;EACE,cAtNe;ACkJjB;;ADuEA;;CAAA;AAGA;EACE,yBA7Qc;EA8Qd,8BAAA;ACpEF;;ADsEA;EACE,WApOY;ACiKd;;ADqEA;;EAEE,0BAAA;AClEF;;ADoEA;;EAEE,0BAAA;ACjEF;;ADmEA;EACE,kBAAA;AChEF;;ADkEA;EACE,kBAAA;AC/DF;;ADiEA;EACE,oCAAA;EACA,gCAAA;AC9DF;;ADiEA;EACE,yBAlPkB;EAmPlB,WA3PY;AC6Ld;;ADgEA;EACE,yBAAA;AC7DF;;AD+DA;EACE,iBAAA;AC5DF;;AD8DA;;EAEE,+BAAA;EACA,iBAAA;AC3DF;;AD6DA;EACE,sBAzQY;AC+Md;AD4DE;EACE,yBAAA;EACA,YAAA;AC1DJ;;AD6DA;EACC,0CAAA;EACC,cA/Qe;ACqNjB;AD4DE;EACE,yCAAA;EACA,YAAA;AC1DJ;;AD8DA;;CAAA;AAGA;EACE,yBAAA;EACA,0BAAA;AC3DF;;AD6DA;EACE,yBAAA;EACA,0BAAA;AC1DF;;AD6DA;;CAAA;AAGA;EACE,sBA1SY;EA2SZ,yBAAA;EACA,qDAAA;AC1DF;;AD4DA;EACE,yBAvSkB;EAwSlB,yBAAA;EACA,eAAA;ACzDF;AD2DE;EACE,cAjTa;ACwPjB;;AD8DA;;CAAA;AAGA;EACE,yBAhUgB;ACqQlB;;AD8DA;EACE,yBAAA;EACA,yBAAA;AC3DF;;AD6DA;EACE,yBA/UoB;EAgVpB,yBAAA;AC1DF;;AD6DA;EACE,UAAA;EACA,eAAA;EACA,eAAA;AC1DF;;AD6DA;;CAAA;AAGA;EACE,sBAnVY;ACyRd;;AD6DA;EACE,yBA/UkB;ACqRpB;;AD8DA;;CAAA;AAGA;EACE,iGAAA;EACA,sBAhWY;ACqSd;;AD8DA;EACE,mBAAA;AC3DF;;AD8DA;EACE,gGAAA;EACA,sBAzWY;AC8Sd;;AD8DA;EACE,mBAAA;AC3DF;;AD8DA;EACE,gGAAA;EACA,sBAlXY;ACuTd;;AD8DA;EACE,mBAAA;AC3DF;;AD8DA;EACE,gGAAA;EACA,sBA3XY;ACgUd;;AD8DA;EACE,mBAAA;AC3DF;;AD8DA;;;;EAIE,WAtYY;AC2Ud;;AD8DA;;CAAA;AAGA;EACE,qCAAA;AC3DF;;AD6DA;EACE,eAAA;AC1DF;;AD4DA;EACE,cAhZe;ACuVjB;;AD6DA;;CAAA;AAGA;EACE,sBAAA;AC1DF;;AD6DA;EACE,yBAAA;AC1DF;;AD6DA;EACE,yBApbkB;EAqblB,WApaY;AC0Wd;;AD4DA;EACE,yBAxbkB;EAyblB,WAxaY;AC+Wd;;AD4DA;EACE,6BAAA;ACzDF;;AD4DA;EACE,2BAAA;ACzDF;;AD4DA;EACE,yBArckB;AC4YpB;;AD4DA;EACE,yBAxcwB;AC+Y1B;;AD4DA;EACE,WA5bY;EA6bZ,6BAAA;EACA,yBAAA;ACzDF;;AD4DA;EACE,yBAndkB;AC0ZpB;;AD6DA;EACE,yBAldgB;ACwZlB;;AD6DA;EACE,eAAA;EACA,gBA/fc;EAggBd,kBAAA;EACA,6BAAA;EACA,yBAAA;EACA,cA7fc;EA8fd,gBAAA;AC1DF;;AD4DA;;;EAGE,yBAngBc;EAogBd,WAvdY;AC8Zd;;AD4DA;EACE,gBAAA;EACA,YAAA;EACA,WA7dY;EA8dZ,yBAzfY;EA0fZ,YAAA;EACA,eAAA;EACA,gBAphBc;AC2dhB;;AD4DA;EACE,yBAhgBY;ACucd;;AD2DA;EACE,yBAzfkB;ACicpB;;AD0DA;EACE,yBA3fwB;ACoc1B;;AD0DA;EACE,cAjgBiB;AC0cnB;;AD2DA;EACE,kBAAA;EACA,kBAAA;EACA,QAAA;ACxDF;;AD2DA;EACE,WA1fY;EA2fZ,yBAthBY;EAuhBZ,YAAA;ACxDF;;AD2DA;EACE,QAAA;ACxDF;;AD2DA;EACE,gBAAA;EACA,YAAA;EACA,yBA1hBW;EA2hBX,WAvgBY;EAwgBZ,eAAA;EACA,gBA5jBc;EA6jBd,YAAA;ACxDF;;AD2DA;EACE,gBAAA;EACA,YAAA;EACA,yBApiBW;EAqiBX,WAjhBY;EAkhBZ,eAAA;EACA,gBAtkBc;EAukBd,YAAA;ACxDF;;AD2DA;EACE,oCAAA;EACA,sBAAA;EACA,2BAAA;ACxDF;;AD2DA;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;ACxDF;;AD2DA;;;EAGE,yBA1jBW;EA2jBX,WAviBY;EAwiBZ,YAAA;ACxDF;;AD2DA;EACE,yBAzlBc;ACiiBhB;;AD2DA;;;EAGE,yBA/lBc;ACuiBhB;;AD2DA;EACE,MAAA;ACxDF;;AD6DA;EACE,aAAA;EACA,kBAAA;AC1DF;;AD6DA;EACE,mBAAA;AC1DF;;AD6DA;EACE,cAAA;EACA,eAAA;EACA,gBAAA;AC1DF;;AD6DA;EACE,UAAA;AC1DF;;AD6DA;EACE,yCA9lBc;EA+lBd,cAnmBkB;ACyiBpB;;AD6DA;EACE,aAvmBkB;AC6iBpB;;AD6DA;EACE,yBAnmBgB;ACyiBlB;;AD6DA;EACE,yBAAA;AC1DF;;AD6DA;EACE,6BAAA;EACA,yBAAA;EACA,WAlmBY;ACwiBd;;AD6DA;;EAEE,yBAxnBkB;EAynBlB,WAxmBY;AC8iBd;;AD4DA;EACE,6BAAA;EACA,yBAAA;EACA,WA7mBY;ACojBd;;AD4DA;EACE,yBA1nBsB;EA2nBtB,WAlnBY;ACyjBd;;AD4DA;;;EAGE,WAxnBY;AC+jBd;;AD4DA;;EAEE,yBAxoBgB;EAyoBhB,WA9nBY;ACqkBd;;AD4DA;EACE,yBAhrBO;ACunBT;;AD4DA;EACE,eAjpBgB;ACwlBlB;;AD4DA;EACE,YA1oBY;ACilBd;;AD4DA;;EAEE,sBAAA;ACzDF;;AD4DA,iBAAA;AAUA;EACE;IACE,gBAAA;EClEF;AACF;ADoEA;EACE;IACE,mCAAA;IACA,qBAAA;IACA,6BAAA;EClEF;EDoEA;IACE,2BAAA;IACA,gBAAA;EClEF;AACF;ADoEA;EACC;;KAAA;AChED;ADoEA;EACE;IACE,uBAAA;EClEF;EDoEA;IACE,6BAAA;EClEF;AACF;ADoEA;EACE;IACE,mCAAA;IACA,qBAAA;IACA,6BAAA;IACA,wBAAA;EClEF;EDoEA;IACE,kBAAA;EClEF;AACF;ADqEA;EACE;IACI,iBAAA;ECnEJ;EDqEA;IACI,gBAAA;ECnEJ;AACF;AAnsBA;EACI,WAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AAqsBJ;AAnsBI;EACI,eAAA;EAEA,iBAAA;AAosBR;AAjsBI;EACI,YAAA;EACA,kBAAA;EACA,kBAAA;AAmsBR;AAhsBI;EACI,WAAA;EACA,kBAAA;AAksBR;AAhsBI;EACI,qBAAA;AAksBR;AA/rBI;EACI,eAAA;EACA,iBAAA;EACA,gBAAA;AAisBR;AA/rBI;EACI,eAAA;EAEA,iBAAA;AAgsBR;AA3rBQ;EACI,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,6BAAA;AA6rBZ;AA3rBY;EAEI,eAAA;AA4rBhB;AAzrBY;EACI,eAAA;EACA,cDxCA;ECyCA,gBD/CA;ECgDA,kBAAA;AA2rBhB;AArrBQ;EACI,YAAA;EACA,yBAAA;EACA,aAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;AAurBZ;AArrBc;EACE,yBAAA;EACA,WAAA;AAurBhB;;AAlrBA;EACI,aAAA;AAqrBJ;;AAlrBA;EACI,eAAA;EACA,kBAAA;AAqrBJ;;AAlrBA;EACE,WD5BY;ACitBd;;AAlrBA;EACE,iBAAA;AAqrBF;;AAlrBA;EACE;IACE,mBAAA;EAqrBF;AACF;AAlrBA;EACI;IACI,wBDbI;ICcJ,UDbG;ICcH,kBAAA;IACA,aDrBW;ECysBjB;AACF;AAjrBA;EACE;IACE,aAAA;IACA,sBAAA;IACA,QAAA;EAmrBF;EAhrBA;IACE,4BAAA;EAkrBF;AACF","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Urbanist:ital,wght@0,100..900;1,100..900&display=swap');\n\nbody {\n  font-family: \"Urbanist\", sans-serif !important;\n}\n\n/* \nscss\n */\n$font-regular: 400;\n$font-medium: 500;\n$font-semiBold: 600;\n$font-bold: 700;\n$font-extraBold: 800;\n$font-black: 900;\n\n$mainBg: #F5F6FA;\n$primary-color: #131F43;\n$icon-bgcolor: #F6F6F6;\n$text-graycolor: #727272;\n$cardIcon1-bg: #F3F4F8;\n$cardIcon1-darkbg: #30231a;\n$cardIcon1-darkbg-icon: #9d785f;\n$cardIcon2-bg: #FAF4FB;\n$cardIcon2-darkbg: #13252a;\n$cardIcon2-darkbg-icon: #3b606a;\n$cardIcon3-bg: #FAF7F3;\n$cardIcon3-darkbg: #2c1a27;\n$cardIcon3-darkbg-icon: #6c4863;\n$cardIcon4-bg: #F5F9FC;\n$cardIcon4-darkbg: #241d3e;\n$cardIcon4-darkbg-icon: #5f538b;\n$cardIcon2-color: #AC44BB;\n$cardIcon3-color: #D69A5F;\n$cardIcon4-color: #176CA5;\n$green-color: #38A169;\n$darkGreen-color: #207a4a;\n$placeholder-color: #666666;\n$profile-dark-text: #181818;\n$heading : #0B0D0F;\n$light-gray : #999999;\n$menu_icon : #CBCBCB;\n$red-color : #F94747;\n$dark-active-blue : #3b82f6;\n$dark-light-blue : #92afd3;\n$addBtn-dark-blue : #3b82f6;\n$addBtn-dark-blue-hover : #2563eb;\n$backBtn-dark : #3b82f633;\n\n\n\n$darkTheme_blue : #132337;\n$darkTheme_darkBlue : #0f1824;\n$darkTheme_selectBlue : #1c2e45;\n$darkTheme_updateBtn : #0a2574;\n\n/* \nBody Theme Color\n */\n$lightthemecolor: #f3f6f9;\n$darkthemecolor: #151521;\n\n$white-color: #fff;\n$black-color: #1d1d1d;\n$fullBlack-color: #1d1d1d;\n$lightthemetext: #60677e;\n\n/* \nDark Theme Colors\n*/\n$primarydark-color: #132337;\n\n/* \nButton Theme\n*/\n$primary-btncolor: #131F43;\n$secondary-btncolor: rgba(37, 105, 109, 0.864);\n\n$tableheadlightbg: #e9eaf0;\n\n\n/* \nMax Dashboard scss\n*/\n$dashboardwidth: calc(100% - 320px);\n$dashboardposition: absolute;\n$dashboardleft: 310px;\n$dashboardpadding: 30px;\n\n/* \nMin Dashboard scss\n*/\n$dashwidth: calc(100% - 50px);\n$dashleft: 50px;\n\n/* \nMax Dashboard scss\n*/\n\n.dashboard {\n  width: $dashboardwidth;\n  position: relative;\n  left: $dashboardleft;\n  padding: $dashboardpadding;\n  border-radius: 8px;\n  min-height: auto !important;\n  background-color: $mainBg;\n  height: calc(100vh - 160px);\n  overflow-y: auto;\n}\n.dashboardContain { \n  width: calc(100% - 320px);\n  background-Color:$mainBg;\n  border-radius: 8px;\n}\n.bodythemedark .dashboardContain,\n.bodythemedark .dashboard, \n.bodythemedark .cont2 { \n  background-Color: $darkTheme_darkBlue;\n}\n.top_header .top_header_inner {\n  background-color: transparent;\n  height: auto;\n  overflow-y: unset;\n}\n\n/* \nMin Dashboard scss\n*/\n\n.cont2 {\n  width: $dashwidth;\n  left: $dashleft;\n  position: relative;\n  padding: $dashboardpadding;\n  border-radius: 8px;\n  background: $mainBg;\n  height: calc(100vh - 160px);\n  min-height: auto !important;\n  overflow-y: auto;\n  /* \nbackground-Color: $dashboardbackgroundColor;\n  padding-bottom: 8%;\n*/\n}\n\n\n\n\n.footer {\n  height: 70px;\n}\n\nbody {\n  background-color: $white-color;\n}\n\n/* \nTHEME CHANGE\n*/\n.bodythemelight {\n  background-color: $white-color;\n  padding-top: 90px;\n}\n.bodythemedark {\n  background-color: $darkTheme_blue;\n  padding-top: 90px;\n}\n\n/* \nHeader Navbar Theme\n*/\n.headerthemelight {\n  background-color: $white-color;\n}\n\n.headerthemedark {\n  background-color: $darkTheme_blue;\n}\n.top_header {\n  min-height: 90px;\n  display: flex;\n  align-items: center;\n  position: fixed;\n  width: 100%;\n  z-index: 1; \n  top: 0;\n}\n\n/* \nLEFT MENU THEME CHANGE\n*/\n.menuthemelight {\n  background-color: $white-color;\n}\n.menuthemedark {\n  background-color: $darkTheme_blue;\n}\n\n/* \nLEFT MENU LINKS THEME CHANGE\n*/\n.menulinklight span {\n  color: $placeholder-color !important;\n}\n\n.menulinklight a {\n  color: $menu_icon !important;\n}\n\n.menulinklight:hover span, .menulinklight:hover a { \n  color: $white-color !important;\n}\n\n.menulinkdarkSelected {\n  background-color: $darkTheme_selectBlue;\n  color: $dark-active-blue;\n}\n.menuthemelight .menulinklightSelected {\n  /*background-color: $lightthemecolor;*/\n  color: $white-color !important;\n  background-color: $primary-color;\n}\n\n.menulinkdark {\n  color: $dark-light-blue !important;\n}\n\n.menulinklight:hover {\n  color: $white-color !important;\n  background-color: $primary-color;\n}\n\n.menulinklight .sub_arrow svg path{\n  stroke: $menu_icon !important;\n}\n\n.menulinklight:hover .sub_arrow svg path{\n  stroke: $white-color !important;\n}\n\n.menulinkdark .sub_arrow svg path{\n  stroke: $dark-light-blue !important;\n}\n\n.menulinkdark:hover .sub_arrow svg path{\n  stroke: $white-color !important;\n}\n\n.menulinkdark:hover {\n  background-color: $darkTheme_selectBlue;\n  color: $white-color;\n}\n\n/* \nBODY HEADERS\n*/\n.headinglight {\n  color: $lightthemetext;\n}\n\n.headingdark {\n  color: $lightthemetext;\n}\n\n/* \nSEARCH BOX THEME COLOR\n*/\n.searchboxlight {\n  background-color: $white-color;\n  border: none;\n}\n\n.searchboxdark {\n  background-color: $darkTheme_blue;\n  color: $white-color;\n  border: none;\n}\n.searchboxdark::placeholder {\n  color: $lightthemetext;\n}\n\n/* \nCUSTOM TABLE THEME COLOR\n*/\n.tableheadlight {\n  background-color: $primary-color;\n  border-radius: 5px 5px 0px 0px;\n}\n.tableheadlight th {\n  color: $white-color;\n}\nthead .tableheadlight th:first-child,\nthead .tableheaddark th:first-child {\n  border-radius: 5px 0 0 0px;\n} \nthead .tableheadlight th:last-child,\nthead .tableheaddark th:last-child  {\n  border-radius: 0 5px 0px 0;\n}\nth:first-child {\n  border-radius: 0px;\n} \ntd:last-child {\n  border-radius: 0px;\n}\ntable.table.table-borderless{\n  border-collapse: separate !important;\n  border-spacing: 0 0px !important;\n}\n\n.tableheaddark {\n  background-color: $primarydark-color;\n  color: $white-color;\n}\n.table-borderless tr:nth-child(even) {\n  background-color: #F9FAFB;\n}\n.table-borderless .left-section {\n  padding-top: 10px;\n}\n.tablebodylight td, \n.tablebodydark td {\n  padding: 0.5rem 1rem !important;\n  line-height: 45px;\n}\n.tablebodylight {\n  background-color: $white-color;\n\n  &:hover {\n    background-color: #ddecf9;\n    cursor: auto;\n  }\n}\n.tablebodydark {\n /* background-color: $primarydark-color; */\n  color: $lightthemetext;\n\n  &:hover {\n    background-color: rgba(33, 150, 243, 0.1);\n    cursor: auto;\n  }\n}\n\n/* \nPAGINATION THEME COLOR\n*/\n.paginationlight {\n  color: $lightthemetext !important;\n  font-size: 13px !important;\n}\n.paginationdark {\n  color: $lightthemetext !important;\n  font-size: 13px !important;\n}\n\n/* \nSETTING FORM THEME COLOR\n*/\n.formthemelight {\n  background-color: $white-color;\n  color: $black-color !important;\n  box-shadow: 0px 10px 35px 0px rgb(56 71 109 / 8%);\n}\n.formthemedark {\n  background-color: $primarydark-color;\n  color: $lightthemetext !important;\n  font-size: 14px;\n\n  ::placeholder {\n    color: $lightthemetext;\n  }\n}\n\n\n/* \nVIEW FORM DETAILS BOX THEME COLOR\n*/\n.viewformlight {\n  background-color: $lightthemecolor;\n}\n\n.permissionboxlight {\n  background-color: #f8f9fa;\n  border: 1px solid #dee2e6;\n}\n.permissionboxdark {\n  background-color: $darkTheme_darkBlue;\n  border: solid 1px #242434;\n}\n\n.errormsgclr {\n  color: red;\n  font-size: 14px;\n  margin-top: 5px;\n}\n\n/* \nGraph theme\n*/\n.graphclrlight {\n  background-color: $white-color;\n}\n\n.graphclrdark {\n  background-color: $primarydark-color;\n}\n\n\n/* \nCounter theme\n*/\n#card1bglight {\n  /* background: linear-gradient(90deg, rgba(181, 219, 177, 1) 13%, rgba(125, 178, 144, 1) 100%); */\n  background-color: $white-color;\n}\n\n#card1bgdark {\n  background: #392f28;\n}\n\n#card2bglight {\n  /* background: linear-gradient(90deg, rgba(243, 198, 165, 1) 0%, rgba(248, 163, 168, 1) 100%); */\n  background-color: $white-color;\n}\n\n#card2bgdark {\n  background: #1c3238;\n}\n\n#card3bglight {\n  /* background: linear-gradient(90deg, rgba(213, 149, 211, 1) 0%, rgba(174, 132, 192, 1) 100%); */\n  background-color: $white-color;\n}\n\n#card3bgdark {\n  background: #3a2434;\n}\n\n#card4bglight {\n  /* background: linear-gradient(90deg, rgba(140, 212, 214, 1) 0%, rgba(150, 202, 247, 1) 100%); */\n  background-color: $white-color;\n}\n\n#card4bgdark {\n  background: #2f264f;\n}\n\n#card1bgdark a, #card1bgdark p,\n#card2bgdark a , #card2bgdark p,\n#card3bgdark a, #card3bgdark p,\n#card4bgdark a, #card4bgdark p {\n  color: $white-color;\n}\n\n/* \nAction button theme\n*/\n.actionbtnlight {\n  color: #46475bde;\n}\n.actionbtnlight:hover{\n  cursor: pointer;\n}\n.actionbtndark {\n  color: $lightthemetext;\n}\n\n\n/* \nprofile dropdowntheme\n*/\n.profiledropdownlight {\n  background-color: #fff;\n}\n\n.profiledropdowndark {\n  background-color: #151521;\n}\n\n.settingsection #addform.formthemedark .savebtn {\n  background-color: $addBtn-dark-blue;\n  color: $white-color;\n}\n#addform.formthemedark .savebtn {\n  background-color: $addBtn-dark-blue;\n  color: $white-color;\n}\n\n.profile_conatiner {\n  border-radius: 5px !important; \n}\n\n.bodythemedark .ag-theme-alpine .ag-row {\n  background: #000 !important;\n}\n\n.bodythemedark .formbtn {\n  background-color: $addBtn-dark-blue;\n}\n\n.bodythemedark .formbtn:hover {\n  background-color: $addBtn-dark-blue-hover;\n}\n\n.bodythemedark .resetbtn {\n  color: $white-color;\n  background-color: transparent;\n  border: solid 1px $addBtn-dark-blue;\n}\n\n.bodythemedark .resetbtn:hover {\n  background-color: $addBtn-dark-blue;\n}\n\n\n.headingdark span {\n  background-color: $darkTheme_blue;\n}\n\n.resetbtn {\n  font-size: 16px;\n  font-weight: $font-semiBold;\n  border-radius: 5px;\n  background-color: transparent;\n  border: solid 1px $primary-color;\n  color:  $primary-color;\n  min-width: 113px;\n}\n.resetbtn:hover, \n.resetbtn:active, \n.resetbtn:focus {\n  background-color: $primary-color;\n  color: $white-color;\n}\n\n.addBtn {\n  min-width: 140px;\n  height: 44px;\n  color: $white-color;\n  background-color: $green-color;\n  border: none;\n  font-size: 16px;\n  font-weight: $font-semiBold;\n}\n\n.addbtnlight {\n  background-color: $green-color;\n}\n.addbtndark {\n  background-color: $addBtn-dark-blue;\n}\n.addbtndark:hover {\n  background-color: $addBtn-dark-blue-hover;\n}\n\n.formthemedark label {\n  color: $dark-light-blue;\n}\n\n\n.addBtn svg {\n  margin-right: 10px;\n  position: relative;\n  top: 2px;\n}\n\n.addBtn:hover {\n  color: $white-color;\n  background-color: $green-color;\n  border: none;\n}\n\n.cust_addBtn.addBtn svg {\n  top: 2px;\n}\n\n.deleteBtn {\n  min-width: 130px;\n  height: 50px;\n  background-color: $red-color;\n  color: $white-color;\n  font-size: 16px;\n  font-weight: $font-semiBold;\n  border: none;\n}\n\n.deleteBtn {\n  min-width: 130px;\n  height: 50px;\n  background-color: $red-color;\n  color: $white-color;\n  font-size: 16px;\n  font-weight: $font-semiBold;\n  border: none;\n}\n\n.deleteBtn:active, .deleteBtn:focus {\n  background-color: $red-color !important;\n  color: $white-color !important; \n  box-shadow: none !important;\n}\n\n.deleteBtn svg {\n  margin-right: 10px;\n  position: relative;\n  top: -2px;\n}\n\n.deleteBtn:hover, \n.deleteBtn:active, \n.deleteBtn:focus {\n  background-color: $red-color;\n  color: $white-color;\n  border: none;\n}\n\n.confirmBtn {\n  background-color: $primary-color;\n}\n\n.confirmBtn:hover, \n.confirmBtn:active, \n.confirmBtn:focus {\n  background-color: $primary-color;\n}\n\n.confirmBtn svg {\n  top: 0;\n}\n\n\n\n.delPopContainer .modal-body {\n  padding: 25px;\n  text-align: center;\n}\n\n.delPopContainer .delet_icon {\n  margin-bottom: 11px;\n}\n\n.delPopContainer p {\n  color: #131f43;\n  font-size: 14px;\n  font-weight: 700;\n}\n\n.arrowback svg{\n  fill: #000; \n}\n\n.bodythemedark .arrowback {\n  background-color: $backBtn-dark; \n  color: $dark-active-blue;\n}\n\n.bodythemedark .arrowback svg {\n  fill: $dark-active-blue;\n}\n\n.bodythemedark .drpdwn_btn {\n  background-color: $darkTheme_blue;\n}\n\n.bodythemedark .empname {\n  color: $dark-light-blue !important;\n}\n\n.bodythemedark .navitemli a {\n  background-color: transparent;\n  border: solid 1px $addBtn-dark-blue;\n  color: $white-color;\n}\n\n.bodythemedark .tabnavli a.settingsgeneral, \n.bodythemedark .tabnavli a.settingslinks:hover {\n  background-color: $addBtn-dark-blue;\n  color: $white-color;\n}\n.bodythemedark .tabnavli a.settingslinks {\n  background-color: transparent;\n  border: solid 1px $addBtn-dark-blue;\n  color: $white-color;\n}\n\n.headerthemedark .dropdown_menu_contain {\n  background-color: $darkTheme_selectBlue;\n  color: $white-color;\n}\n\n.headerthemedark .dropdown_menu_contain ul li a,\n.headerthemedark .dropdown_menu_contain .dropdown_item, \n.headerthemedark .dropdown_menu_contain .dropdown_item h5 {\n  color: $white-color;\n}\n\n.headerthemedark .dropdown_menu_contain ul li a:hover,\n.headerthemedark .dropdown_menu_contain .dropdown_item:hover {\n  background-color: $darkTheme_blue;\n  color: $white-color;\n}\n\n.dropdown_item:active {\n  background-color: $mainBg;\n}\n\n.profile_arrrow_dwn {\n  stroke: $darkTheme_blue;\n}\n\n.headerthemedark .profile_arrrow_dwn {\n  stroke: $white-color;\n}\n\n.dateinputbox1 input, \n.dateinputbox1 span {\n  color: $white-color !important;\n}\n\n/* LOGOUT MODAL */\n.modalStyleLight {\n\n}\n\n.modalStyleDark {\n  \n}\n\n\n@media only screen and (max-width: 1200px) {\n  .tableheadlight th {\n    min-width: 100px;\n  }\n}\n@media only screen and (max-width: 1024px) { \n  .dashboard {\n    width: calc(100% - 50px) !important;\n    left: 50px !important;\n    padding: 10px 10px !important;\n  }\n  .cont2 {\n    height: calc(100vh - 160px);\n    overflow-y: auto;\n  }\n}\n@media only screen and (max-width: 998px) { \n /* #dashboardcont2{\n    height: auto !important;\n  }*/\n}\n@media only screen and (max-width: 767px) { \n  .sectionright{\n    float: unset !important;\n  }\n  .dashboard {\n    padding: 10px 10px !important;\n  }\n}\n@media only screen and (max-width: 600px) {\n  .cont2 {\n    width: $dashwidth !important;\n    left: $dashleft !important;\n    position: relative !important;\n    padding: 10px !important;\n  }\n  .bodythemelight, .bodythemedark {\n    padding-top: 110px;\n  }\n}\n\n@media (min-width: 576px) {\n  .exer_modal_contain .modal-dialog {\n      max-width: 1055px;\n  }\n  .delPopContainer .modal-dialog {\n      max-width: 350px;\n  }\n}","@import \"../../styles/Variables/Variables.scss\";\n\n\n#addform{\n    width: 100%;\n    border-radius: 5px;\n    margin-top: 30px;\n    margin-bottom: 20px;\n   \n    #addheading{\n        font-size: 18px;\n         \n        margin-left: 10px;\n    }\n\n    .profilepicdiv{\n        padding: 0px;\n        border-radius: 5px;\n        text-align: center;\n    }\n\n    .profilepic{\n        width: 100%;\n        border-radius: 5px;\n    }\n    .namesection{\n        display: inline-block;\n    }\n\n    .profilename{\n        font-size: 16px;\n        margin-left: 20px;\n        margin-top: 30px;\n    }\n    .profileemail{\n        font-size: 14px;\n         \n        margin-left: 20px;\n    }\n   \n\n\n        #empdiv{\n            padding: 0px;\n            margin-bottom: 20px;\n            border-radius: 5px;\n            display: flex;\n            align-items: center;\n            background-color: transparent;\n\n            .title{\n                 \n                font-size: 13px;\n            }\n\n            .empname{\n                font-size: 16px;\n                color: $primary-color;\n                font-weight: $font-semiBold;\n                margin-bottom: 0px;\n                // padding-bottom:8px;\n            }\n        }\n\n        \n        .arrowback{\n            float: right;\n            background-color: #dde2eb;\n            padding: 10px;\n            color: #39979d;\n            cursor: pointer;\n            border-radius: 3px;\n    \n              &:hover{\n                background-color: #39979d;\n                color: #fff;\n              }\n          }\n}\n\n.profile_view_container {\n    padding: 30px;\n}\n\n.profile_view_container span {\n    font-size: 13px;\n    margin-bottom: 7px;\n}\n\n.formthemedark.profile_view_container span {\n  color: $white-color;\n}\n\n.deleteBtn svg {\n  margin-right: 0px;\n}\n\n@media only screen and (max-width: 992px) {\n  .profilepicdiv{\n    margin-bottom: 30px;\n  }\n}\n\n@media only screen and (max-width: 600px) {\n    #dashboardcont2{\n        width: $dashwidth;\n        left: $dashleft;\n        position: relative;\n        padding: $dashboardpadding;\n    }\n}\n\n@media only screen and (max-width: 767px) {\n  .btn_contain > div {\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n  }\n\n  .btn_contain > div button {\n    margin-right: 0px !important;\n  }\n  \n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dashboard": `viewUser_dashboard__iThb1`,
	"dashboardContain": `viewUser_dashboardContain__2kzL3`,
	"bodythemedark": `viewUser_bodythemedark__wulnI`,
	"cont2": `viewUser_cont2__-kuqZ`,
	"top_header": `viewUser_top_header__7hDIR`,
	"top_header_inner": `viewUser_top_header_inner__M6rMm`,
	"footer": `viewUser_footer__jbCYz`,
	"bodythemelight": `viewUser_bodythemelight__0PGJc`,
	"headerthemelight": `viewUser_headerthemelight__SlKj2`,
	"headerthemedark": `viewUser_headerthemedark__NMtco`,
	"menuthemelight": `viewUser_menuthemelight__V31yz`,
	"menuthemedark": `viewUser_menuthemedark__YSvyO`,
	"menulinklight": `viewUser_menulinklight__TMqfU`,
	"menulinkdarkSelected": `viewUser_menulinkdarkSelected__QX0Vz`,
	"menulinklightSelected": `viewUser_menulinklightSelected__jqaxe`,
	"menulinkdark": `viewUser_menulinkdark__rBWoe`,
	"sub_arrow": `viewUser_sub_arrow__ZXCe2`,
	"headinglight": `viewUser_headinglight__3ordU`,
	"headingdark": `viewUser_headingdark__YUOnG`,
	"searchboxlight": `viewUser_searchboxlight__lT-JP`,
	"searchboxdark": `viewUser_searchboxdark__IaMcG`,
	"tableheadlight": `viewUser_tableheadlight__ucFTs`,
	"tableheaddark": `viewUser_tableheaddark__U9m4X`,
	"table": `viewUser_table__+Pzzo`,
	"table-borderless": `viewUser_table-borderless__rPFk2`,
	"left-section": `viewUser_left-section__xMnO3`,
	"tablebodylight": `viewUser_tablebodylight__kEXJa`,
	"tablebodydark": `viewUser_tablebodydark__aRWdM`,
	"paginationlight": `viewUser_paginationlight__0df3c`,
	"paginationdark": `viewUser_paginationdark__2SShC`,
	"formthemelight": `viewUser_formthemelight__l7JgF`,
	"formthemedark": `viewUser_formthemedark__O6Pbp`,
	"viewformlight": `viewUser_viewformlight__fWN3w`,
	"permissionboxlight": `viewUser_permissionboxlight__g2Jzw`,
	"permissionboxdark": `viewUser_permissionboxdark__u5Qv4`,
	"errormsgclr": `viewUser_errormsgclr__c9+6D`,
	"graphclrlight": `viewUser_graphclrlight__qXmCC`,
	"graphclrdark": `viewUser_graphclrdark__0JXBj`,
	"card1bglight": `viewUser_card1bglight__5BhlI`,
	"card1bgdark": `viewUser_card1bgdark__NLxYm`,
	"card2bglight": `viewUser_card2bglight__zKXly`,
	"card2bgdark": `viewUser_card2bgdark__UDFQ+`,
	"card3bglight": `viewUser_card3bglight__ivWjs`,
	"card3bgdark": `viewUser_card3bgdark__qWBhh`,
	"card4bglight": `viewUser_card4bglight__ThLGp`,
	"card4bgdark": `viewUser_card4bgdark__fZIls`,
	"actionbtnlight": `viewUser_actionbtnlight__XcYy0`,
	"actionbtndark": `viewUser_actionbtndark__s2vFY`,
	"profiledropdownlight": `viewUser_profiledropdownlight__LuxDl`,
	"profiledropdowndark": `viewUser_profiledropdowndark__WGyp9`,
	"settingsection": `viewUser_settingsection__I1Pyw`,
	"addform": `viewUser_addform__sOr4v`,
	"savebtn": `viewUser_savebtn__Z+kf3`,
	"profile_conatiner": `viewUser_profile_conatiner__NCKkX`,
	"ag-theme-alpine": `viewUser_ag-theme-alpine__oTcfv`,
	"ag-row": `viewUser_ag-row__lSzTA`,
	"formbtn": `viewUser_formbtn__0o0PL`,
	"resetbtn": `viewUser_resetbtn__bmzBN`,
	"addBtn": `viewUser_addBtn__pR+UV`,
	"addbtnlight": `viewUser_addbtnlight__tRx63`,
	"addbtndark": `viewUser_addbtndark__9twrN`,
	"cust_addBtn": `viewUser_cust_addBtn__6Rg36`,
	"deleteBtn": `viewUser_deleteBtn__zaPsW`,
	"confirmBtn": `viewUser_confirmBtn__El-A9`,
	"delPopContainer": `viewUser_delPopContainer__t7fHG`,
	"modal-body": `viewUser_modal-body__uYle-`,
	"delet_icon": `viewUser_delet_icon__AoG2x`,
	"arrowback": `viewUser_arrowback__C5ITR`,
	"drpdwn_btn": `viewUser_drpdwn_btn__j+g4R`,
	"empname": `viewUser_empname__wUtTf`,
	"navitemli": `viewUser_navitemli__rhyKP`,
	"tabnavli": `viewUser_tabnavli__-YHAh`,
	"settingsgeneral": `viewUser_settingsgeneral__KG42X`,
	"settingslinks": `viewUser_settingslinks__PQxdD`,
	"dropdown_menu_contain": `viewUser_dropdown_menu_contain__t16Qi`,
	"dropdown_item": `viewUser_dropdown_item__W4kq2`,
	"profile_arrrow_dwn": `viewUser_profile_arrrow_dwn__qZsYl`,
	"dateinputbox1": `viewUser_dateinputbox1__jcn-2`,
	"sectionright": `viewUser_sectionright__vCzZg`,
	"exer_modal_contain": `viewUser_exer_modal_contain__7594D`,
	"modal-dialog": `viewUser_modal-dialog__BgNTR`,
	"addheading": `viewUser_addheading__vGTQP`,
	"profilepicdiv": `viewUser_profilepicdiv__DW1M2`,
	"profilepic": `viewUser_profilepic__PAI2d`,
	"namesection": `viewUser_namesection__oFNuW`,
	"profilename": `viewUser_profilename__1y1cK`,
	"profileemail": `viewUser_profileemail__zoh+F`,
	"empdiv": `viewUser_empdiv__cOJ0m`,
	"title": `viewUser_title__NZ-pF`,
	"profile_view_container": `viewUser_profile_view_container__M3WBK`,
	"dashboardcont2": `viewUser_dashboardcont2__nCgwF`,
	"btn_contain": `viewUser_btn_contain__4cn42`
};
export default ___CSS_LOADER_EXPORT___;
